var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 right-0 overflow-hidden w-24 h-24 z-10"},[_c('div',{staticClass:"ribbon bg-red-600 text-white text-xs text-center uppercase font-bold absolute transform pt-1 pb-1 w-24 left-1/2"},[_vm._v(" "+_vm._s(_vm.$translate('new'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }